import React from 'react';

export const isV4 = (model) => model === 'eleven_v4' || model === 'eleven_v4_turbo';

export const V4VoiceControls = ({ config, onChange, textPrimary, textSecondary }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8" data-testid="v4-voice-controls">
    {[['voice_v4_stability', 'Stability', .5, 'Expressive', 'Steady'],
      ['voice_similarity', 'Similarity', .8, 'Flexible', 'Close to original']].map(([key, label, initial, low, high]) => {
      const value = config[key] ?? initial;
      return (
        <div key={key} className="min-w-0">
          <div className="flex items-center justify-between gap-3 mb-3">
            <label htmlFor={`v4-${key}`} className={`text-sm ${textSecondary}`}>{label}</label>
            <output htmlFor={`v4-${key}`} data-testid={`v4-${key}-value`} className={`text-sm font-mono tabular-nums ${textPrimary}`}>{Math.round(value * 100)}%</output>
          </div>
          <input id={`v4-${key}`} data-testid={`v4-${key}-slider`} type="range" min="0" max="1" step="0.01"
            value={value} onChange={e => onChange(key, Number(e.target.value))}
            className="w-full h-2 cursor-pointer accent-teal-400 focus-visible:outline-teal-400" />
          <div className={`flex justify-between gap-3 mt-2 text-xs ${textSecondary}`}><span>{low}</span><span className="text-right">{high}</span></div>
        </div>
      );
    })}
  </div>
);